export const get64 = (hi, lo) => [hi | 0, lo | 0];
